/*@flow*/

import Present from 'lib/Present';
import keepNonEmptyKeys from 'lib/keepNonEmptyKeys';

export default (setParams: Function, dataviewId: string) => (
  _: string,
  payload: { values?: string[] } | null
) => {
  if (Present.is(payload) && payload !== null) {
    const { values } = payload;
    const filters = keepNonEmptyKeys({
      accept: values,
    });
    // apply filters
    setParams({
      filters: {
        dataviews: {
          [dataviewId]: filters,
        },
      },
    });
  }
};
